export enum ButtonType {
	default = 'default',
	primary = 'primary',
	transparent = 'transparent',
	underline = 'underline',
	outline = 'outline',
	outlineV2 = 'outline-v2',
	delete = 'delete',
	variant5 = 'variant5',
	variant6 = 'variant6',
	blue_light = 'blue-light',
	green = 'green'
}

export enum ButtonSizeType {
	big = 'big',
	medium = 'medium',
	small = 'small',
	b_xl = 'b_xl',
	b_xxl = 'b_xxl',
	extra_small = 'extra_small'
}
